import { Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

/**
 * Empty state of the channel list while a search term is typed. Separate from
 * ChatChannelListEmpty because "nothing here yet" is wrong for a search that simply found no
 * conversation, and the SDK takes a component, not props.
 */
export const ChatChannelSearchEmpty = () => {
  const { t } = useResource();

  return (
    <Stack alignItems="center" justifyContent="center" height="100%" p={3}>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {t(Resources.Chat.NoSearchResults)}
      </Typography>
    </Stack>
  );
};
